import React from "react";
import {ThreeBounce} from "better-react-spinkit";
import ProgressBar from "@ramonak/react-progress-bar";

interface SpinnerProps {
  size?: number;
  color?: string;
  scaleStart?: number;
  scaleEnd?: number;
  positionFixed?: boolean;
  spinnerType?: "ThreeBounce";
  progress?: never;
  progressMax?: never;
}

interface ProgressSpinnerProps {
  size?: number;
  color?: string;
  scaleStart?: number;
  scaleEnd?: number;
  positionFixed?: boolean;
  spinnerType: "Progress";
  progress: number;
  progressMax: number;
}

const Spinner: React.FC<SpinnerProps | ProgressSpinnerProps> = ({
                                                                  size = 10,
                                                                  color = "#37434f",
                                                                  //scaleStart = 0.4,
                                                                  //scaleEnd = 0.8,
                                                                  positionFixed = true,
                                                                  spinnerType = "ThreeBounce",
                                                                  progress = 0,
                                                                  progressMax = 100
                                                                }) => {
  switch (spinnerType) {
    case "Progress":
      return <div style={{width: "50%", maxWidth: 500, marginRight: "auto", marginLeft: "auto"}}>
        <ProgressBar
          completed={Math.floor((progress / progressMax) * 100)}
          transitionDuration={"0.1s"}
          bgColor={color}
        />
      </div>
    case "ThreeBounce":
      return (
        <div className={positionFixed ? "Spinner Fixed" : "Spinner"}>
          <ThreeBounce size={size} color={color}/>
        </div>
      );
    default:
      return (
        <div className={positionFixed ? "Spinner Fixed" : "Spinner"}>
          <ThreeBounce size={size} color={color}/>
        </div>
      );
  }
};

export { Spinner };
